import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  // const logo = <YourSvg />;

  const logo = (
    <Box sx={{ width: 70, height: 70, ...sx }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        style={{
          enableBackground: 'new 0 0 2050 2050',
        }}
        viewBox="0 0 2050 2050"
        y={0}
        x={0}
        id="Layer_1"
      >
        <style id="style2" type="text/css">
          {'.st1{fill:transparent}'}
        </style>
        <g id="g40">
          <path
            style={{
              fill: '#39d29b',
              fillOpacity: 0,
            }}
            id="path4"
            d="M-25 2067.71V-21.12c6.43-3.49 13.4-1.78 20.09-1.78 685.02-.09 1370.04-.08 2055.07-.08 24.73 0 24.82.02 24.82 24.02.02 681.92.02 1363.84 0 2045.76 0 25.34-1.03 26.48-24.85 26.47-666.14-.06-1332.28.21-1998.42-.13-19.65-.01-39.3.43-58.96-.24-6.52-.23-12.85.06-17.75-5.19z"
          />
          <g
            style={{
              fill: '#2eb89f',
              fillOpacity: 1,
            }}
            transform="translate(0 -32)"
            id="g38"
          >
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path6"
              d="M1473.79 743.87c-22.08-20.55-47.62-36.47-73.83-54.46 36.73-21.08 71.58-41.13 106.48-61.09 8.18-4.68 15.83-9.79 20.33-18.48 14.22-27.47-5.13-56.09-38.57-56.17-93.67-.22-187.35-.3-281.02.13-15.36.07-16.73-3.23-8.89-16.09 22.27-36.49 43.32-73.73 65.07-110.54 8.45-14.3 13.75-28.83-.13-42.23-13.17-12.71-27.02-7.31-40.79.72-50.86 29.64-101.89 59-152.97 88.25-5.06 2.89-9.51 8.3-17.22 6.18-.22-2.99-.62-5.99-.63-8.99-.05-44.05-.4-88.1.2-132.13.16-11.8-2.79-17.52-15.39-15.71-4.25.61-8.67.02-13.01.11-28.75.56-24.98-4.41-25.14 26.01-.24 43.77-.06 87.55-.06 130.8-6.11 1.73-9.04-.86-12.16-2.67-53.14-30.66-106.33-61.24-159.35-92.1-13.81-8.04-27.59-13.09-40.69-.1-12.95 12.85-8.96 26.58-.58 40.59 21.62 36.17 42.84 72.58 63.88 109.09 2.91 5.04 10.18 10.16 6.48 16.08-3.4 5.42-11.39 2.41-17.29 2.42-93.05.15-186.11.01-279.16.2-20.87.04-34.25 9.86-39.41 27.44-4.98 16.96 1.78 33.21 18.64 44.43 5.68 3.78 11.5 7.33 17.33 10.87 30.57 18.6 61.16 37.15 93.15 56.58-6.52 3.66-11.36 6.14-15.97 8.98-108.92 67.05-163.61 162.52-152.74 292.16 6.02 71.77 30.22 138.16 65.62 199.8 75.29 131.11 152.53 261.11 229.48 391.26 111.72 188.96 386.82 189.11 498.56.38 71.04-119.98 141.83-240.12 212.55-360.29 34.42-58.49 62.66-119.68 76.32-186.6 23.26-114.12-2.07-213.81-89.09-294.83zm-134.38-113.39c-59.22 35.41-120.24 64.92-191.95 54.27-35.83-5.32-63.61-24.45-87.8-54.27h279.75zm-176.82-146.91 3.08 2.9c-12.89 20.55-25.78 41.1-38.66 61.67-2.09 3.34-4.8 5.41-8.99 5.4-21.43-.06-42.86-.03-64.3-.03-.73-1.92-1.46-3.84-2.18-5.76 37.02-21.4 74.04-42.79 111.05-64.18zm-275.98-.15c36.99 21.36 73.99 42.71 110.98 64.07-.3 1.85-.59 3.71-.89 5.56-22.76 0-45.53.17-68.28-.26-2.26-.04-5.04-3.39-6.59-5.83-12.79-20.11-25.34-40.36-37.97-60.58.92-.98 1.84-1.97 2.75-2.96zm103.62 147.24c-34.05 40.69-74.39 58.47-124.36 56.54-59.98-2.31-112.66-25-167.83-56.54h292.19zm479.89 452.92c-21.05 57.41-53.64 108.78-84.42 161.07-58.76 99.86-117.85 199.53-176.72 299.33-41.4 70.18-103.41 104.23-183.24 105.85-76.41-1.26-138.67-30-178.01-95.06C767.26 1421.7 689 1287.28 611.2 1152.62c-29.3-50.71-49.9-105.55-54.97-164.5-9.23-107.48 47.53-195.55 149.53-236.08 23.08-9.17 44.06-11.66 69.39-3.44 56.82 18.44 115.36 22.54 173.64 3.49 24.48-8 46.37-20.67 65.94-37.25 6.38-5.41 10.75-7.85 18.71-1.2 70.52 58.86 150.5 58.95 233.87 36.47 2.38-.64 4.98-1.08 7.01-2.37 31.06-19.63 58.63-7.89 86.21 8.71 60.15 36.18 110.2 80.78 127.73 152.35 14.75 60.27 2.66 118.05-18.14 174.78z"
              className="st1"
            />
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path8"
              d="M1023.94 1426.38c-19.26.37-35.29 16.59-35.52 35.94-.24 19.78 16.66 36.07 37.12 35.77 20.23-.29 35.26-15.29 35.32-35.26.06-19.83-17.17-36.83-36.92-36.45z"
              className="st1"
            />
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path10"
              d="M1026.08 1205.86c-20.59-.87-37.26 14.7-37.64 35.16-.37 19.51 15.05 35.45 34.93 36.12 21.21.71 37.24-14.19 37.63-35 .36-19.2-15.29-35.46-34.92-36.28z"
              className="st1"
            />
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path12"
              d="M1356.69 874.45c-20.61-.43-36.95 15.6-36.75 36.06.19 19.4 16.11 35 35.92 35.21 21.06.22 36.98-15.34 36.82-36-.15-19.17-16.15-34.85-35.99-35.27z"
              className="st1"
            />
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path14"
              d="M692.76 874.45c-20.15.13-35.55 15.18-35.8 35-.26 20.36 15.87 36.33 36.62 36.27 20.57-.06 35.04-14.4 35.25-34.95.23-21.15-14.98-36.46-36.07-36.32z"
              className="st1"
            />
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path16"
              d="M915.13 1166.69c20.22-.31 35.04-15.19 35.23-35.41.19-19.74-17.01-36.71-36.88-36.4-20.7.32-35.07 16.12-34.41 37.82.62 20.46 15.31 34.3 36.06 33.99z"
              className="st1"
            />
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path18"
              d="M1025.9 1056.72c19.72-.62 34.99-16.34 35.04-36.09.06-20.37-15.95-35.42-37.34-35.11-20.39.29-35.36 15.27-35.2 35.23.15 19.51 17.96 36.59 37.5 35.97z"
              className="st1"
            />
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path20"
              d="M1246.39 1056.76c19.68-.28 35.1-15.8 35.37-35.6.29-20.73-15.04-35.69-36.5-35.63-21.31.06-34.66 13.35-34.8 34.64-.13 20.86 15.6 36.88 35.93 36.59z"
              className="st1"
            />
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path22"
              d="M1135.28 1094.89c-19.44-.23-35.34 15.29-35.9 35.03-.58 20.48 15.22 36.71 35.79 36.77 20.74.06 35.18-13.97 35.53-34.51.35-21-14.9-37.06-35.42-37.29z"
              className="st1"
            />
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path24"
              d="M914.28 874.45c-21.15-.16-35.56 14.81-35.2 36.55.34 20.33 15.05 34.81 35.3 34.74 20.22-.07 35.53-14.81 35.98-34.65.48-20.41-15.37-36.48-36.08-36.64z"
              className="st1"
            />
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path26"
              d="M1135.97 945.72c20.71-.26 34.57-14.38 34.72-35.37.15-21.04-15.13-36.15-36.29-35.9-20.26.24-34.95 15.06-35.02 35.36-.09 20.78 15.61 36.18 36.59 35.91z"
              className="st1"
            />
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path28"
              d="M803.47 1056.76c19.79.24 35.28-14.8 35.83-34.8.59-21.54-13.66-36.24-35.31-36.43-20.94-.19-35.44 13.47-35.99 33.89-.56 20.6 15.11 37.09 35.47 37.34z"
              className="st1"
            />
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path30"
              d="M802.08 1205.85c-20.11.66-34.37 15.84-34.09 36.28.28 19.88 15.55 34.95 35.5 35.01 21.61.07 36.09-14.52 35.81-36.1-.26-20.59-16.43-35.87-37.22-35.19z"
              className="st1"
            />
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path32"
              d="M913.58 1316.92c-21.09.06-34.49 13.61-34.52 34.92-.03 20.87 15.65 36.72 35.96 36.36 19.64-.34 35.17-16 35.33-35.63.18-20.33-15.68-35.71-36.77-35.65z"
              className="st1"
            />
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path34"
              d="M1246.46 1205.84c-20.24-.54-35.36 13.78-35.98 34.08-.66 21.49 13.74 36.92 34.73 37.22 21.27.3 36.77-14.82 36.58-35.69-.19-19.72-15.42-35.08-35.33-35.61z"
              className="st1"
            />
            <path
              style={{
                fill: '#2eb89f',
                fillOpacity: 1,
              }}
              id="path36"
              d="M1135.38 1316.92c-21.41-.1-36.54 15.01-36 35.95.51 19.66 16.24 35.22 35.71 35.32 20.95.1 35.83-15.23 35.6-36.68-.22-20.53-14.49-34.5-35.31-34.59z"
              className="st1"
            />
          </g>
          <text
            transform="translate(284.983 1739.822) scale(.22078)"
            id="text935"
            y={1073.235}
            x={3361.143}
            style={{
              fontWeight: 700,
              fontSize: 1536,
              lineHeight: 1.25,
              fontFamily: 'helvari',
              InkscapeFontSpecification: "'helvari Bold'",
              textAlign: 'center',
              textAnchor: 'middle',
              whiteSpace: 'pre',
              inlineSize: 6056.35,
              fill: 'transparent',
              fillOpacity: 1,
            }}
            xmlSpace="preserve"
          >
            <tspan x={3361.143} y={1073.235}>
              <tspan
                style={{
                  fontSize: 1536,
                  textAlign: 'center',
                  textAnchor: 'middle',
                  fill: 'transparent',
                  fillOpacity: 1,
                }}
              >
                {'FarmUp'}
              </tspan>
            </tspan>
          </text>
          <path
            id="path937"
            d="M1244.226 1734.181c-10.949.122-26.81 1.946-21.629 16.741 1.553 58.421-1.41 117.146 3.625 175.371 11 39.439 54.42 59.588 93.018 55.41 38.53 3.774 80.194-19.604 88.288-59.263 6.513-50.45 1.944-101.739 3.354-152.52-2.366-12.506 7.5-34.658-11.545-34.89-10.895-.538-35.272-4.53-34.28 10.97-1.475 55.255 3.478 111.07-4.318 165.936-8.835 41.1-83.183 38.5-87.219-4.376-4.529-56.105-1.506-112.554-2.52-168.795-8.36-4.009-17.627-4.874-26.774-4.584z"
            style={{
              fill: '#2eb89f',
              fillOpacity: 1,
              strokeWidth: 2.41176,
            }}
          />
          <path
            id="path939"
            d="M1532.408 1796.826c-15.138-1.368-29.526 5.65-43.826 7.325-1.264-9.206-13.426 1.819-18.074 3.1-11.99 5.54-20.194 14.303-16.214 28.347.95 69.909-2.18 140.107 2.548 209.833 9.717 9.592 26.838 1.5 39.181 3.465 7.003-7.403 1.385-27.209 3.597-39.32 3.455-8.944-6.923-41.086 8.185-30.487 37.038 15.339 84.614-1.3 100.442-39.15 13.44-27.5 11.857-60.07 5.897-89.24-11.97-34.976-44.534-57.146-81.736-53.873zm6.208 38.584c28.285 1.794 36.535 37.254 33.567 60.604-1.467 23.586-16.646 55.43-44.566 51.806-29.045-9.308-33.661-46.476-31.32-72.626 3-19.49 19.592-44.64 42.32-39.784z"
            style={{
              fill: '#2eb89f',
              fillOpacity: 1,
              strokeWidth: 2.41176,
            }}
          />
          <path
            id="path941"
            d="M1111.955 1793.505c-17.245-.033-34.016 6.252-47.561 16.265-14.419-6.045-27.908-16.467-44.778-14.776-17.651-2.337-35.434 3.36-51.622 7.918-1.03-11.115-15.517-1.59-21.32.65-16.354 7.257-8.32 28.734-10.76 42.512.277 43.302-1.407 87.162 1.72 130.127 13.13.719 29.66 5.117 41.043-2.506 7.05-42.156-1.7-86.11 6.43-128.21 5.478-16.059 29.554-21.143 42.168-11.456 10.634 24.282 5.1 52.5 7.416 78.387l1.162 64.025c13.17-1.2 28.324 4.265 40.5-1.314 6.709-24.094 2.696-50.472 4.138-75.415 2.456-20.82-5.694-46.078 8.623-63.586 14.648-14.755 44.863-4.25 42.649 17.951 2.15 40.745 1.924 81.58 2.972 122.364 13.342-1.679 30.437 5.762 41.73-3.076 4.577-44.42 3.77-89.638.523-134.182-3.195-32.514-35.056-48.535-65.033-45.678z"
            style={{
              fill: '#2eb89f',
              fillOpacity: 1,
              strokeWidth: 2.41176,
            }}
          />
          <path
            id="path943"
            d="M879.522 1796.939c-14.942.076-29.785 3.712-42.64 11.447 3.14-9.444-3.142-13.082-10.97-8.088-11.03 3.876-27.497 8.083-22.794 23.11.662 50.853-1.534 102.283 1.874 152.793 13.465 1.175 28.816 3.84 41.5-.984 4.916-41.522 2.15-84.233 3.633-126.205 5.087-11.967 20.092-15.954 31.997-10.739 13.163 4.05 32.153 1.47 32.968-15.61 3.957-19.498-20.345-27.497-35.568-25.724z"
            style={{
              fill: '#2eb89f',
              fillOpacity: 1,
              strokeWidth: 2.41176,
            }}
          />
          <path
            id="path945"
            d="M695.742 1796.887c-33.741-3.12-74.824 17.467-75.476 55.07 5.539 10.8 23.48 14.674 33.986 10.029 12.42-19.18 38.398-39.979 61.284-25.53 10.259 6.025 10.735 28.055-4.103 27.25-32.471 8.285-75.106 9.787-92.274 43.854-12.114 28.028.856 68.574 34.636 72.292 20.319 6.222 40.73-2.502 60.888-2.224 14.74 7.83 38.152 6.473 47.434-7.146-1.23-46.95 2.783-94.517-3.452-141.083-10.75-25.018-36.969-35.283-62.923-32.512zm20.552 115.016c2.026 15.696-4.615 34.41-22.855 35.602-16.405 5.376-39.519-7.342-31.494-26.633 10.978-18.252 35.483-19.242 54.35-23.35v14.38z"
            style={{
              fill: '#2eb89f',
              fillOpacity: 1,
              strokeWidth: 2.41176,
            }}
          />
          <path
            id="path947"
            d="M545.261 1734.257c-31.844 1.58-64.472-1.99-95.844 3.65-7.842 10.12-2.754 26.123-4.973 38.323-.571 66-2.318 132.345 3.654 198.106 12.516 5.56 29.467 3.748 43.007.734 6.275-26.36 1.937-55.047 3.307-82.263-5.33-20.342 5.818-24.46 24.115-21.536l61.502-.948c-1.35-10.939 5.302-26.815-3.476-35.286-27.083-4.093-54.809-1.202-82.141-2.096v-57.882c31.8-1.54 64.46 3.299 95.73-3.057 8.996-7.007 6.277-22.645 3.458-32.286-13.168-9.057-33.283-3.97-48.339-5.46z"
            style={{
              fill: '#2eb89f',
              fillOpacity: 1,
              strokeWidth: 2.41176,
            }}
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
